import { Icon, NoBorderWrapper, TEXT_LENGTH } from '@nile/components';
import { Plus } from '@styled-icons/fa-solid';
import { SVGIcon } from '@superops/super-icons';
import { Button, TextField } from '@superops/ui-design-system';
import React, { useCallback, useEffect, useState } from 'react';

function AddInput(props) {
  const { superId = 'addInputCategory' } = props;
  const [textFieldValue, setTextFieldValue] = useState('');
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    setErrors(props?.errors);
  }, [props?.errors]);

  const handleTextFieldChange = useCallback((value) => {
    setTextFieldValue(value);
    setErrors([]);
  }, []);

  const handleEnterKey = (e) => {
    if (e.which === 13 || e.charCode === 13 || e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      props.update(textFieldValue);
      setTextFieldValue('');
    }
  };

  const onAdd = () => {
    props.update(textFieldValue);
    setTextFieldValue('');
  };

  return (
    <span id={props.id} onKeyPress={handleEnterKey}>
      <div className="fx actr category-add-input" superid={superId}>
        <div className="full-width pr10">
          <NoBorderWrapper>
            <TextField
              noborder
              type="text"
              value={textFieldValue}
              onChange={handleTextFieldChange}
              error={errors?.[0]}
              placeholder={props?.placeholder}
              maxLength={TEXT_LENGTH.size_4}
            />
          </NoBorderWrapper>
        </div>

        <div className="fx actr jend">
          <Button
            size="tiny"
            onClick={onAdd}
            plain
            icon={<SVGIcon name="Add" size="sm" />}
          />
        </div>
      </div>
    </span>
  );
}

export default AddInput;
